import { Badge, SxProps, Tooltip } from "@mui/material"
import { Box } from "@mui/system"
import { useStore } from "@priolo/jon"
import { FunctionComponent } from "react"
import drawerSo from "stores/mainMenu/drawer"
import { MenuItem } from "stores/mainMenu/types"
import theme from "styles/theme"
import PageIcon from "./PageIcon"



interface Props {
	item: MenuItem

	select?: boolean
	badge?: string
	highlight?: boolean
	tooltip?: string
	disabled?: boolean

	onClick?: () => void
}

const SectionItem: FunctionComponent<Props> = ({
	item,

	select = false,
	badge = null,
	highlight = false,
	tooltip = null,
	disabled,

	onClick,
}) => {

	// STORES
	const drawerSa = useStore(drawerSo)

	// HOOKs

	// HANDLER
	const handleClick = () => {
		onClick()
	}

	// RENDER
	const cnContainer: SxProps = [
		sxContainer,
		select && sxSelect,
		highlight && sxHighlight(select),
		disabled && sxDisabled,
		{ position: "relative" },
		{ color: !!badge ? "secondary.main" : null }
	]
	tooltip = drawerSa.isCompact ? item.title : tooltip

	return (
		<Box sx={cnContainer}
			data-test={`mainmenu-${item.id}`}
			onClick={!disabled ? handleClick : undefined}
		>
			<Tooltip placement="right" title={tooltip}>
				<Badge sx={sxBadge}
					color="secondary"
					badgeContent={badge}
					invisible={!badge}
					anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
				>
					<Box sx={sxIcon}><PageIcon pageId={item.id} /></Box>
				</Badge>
			</Tooltip>

			<Box sx={cssLabel(drawerSa.isCompact)}>
				{item.title}
			</Box>

			{item.divider && <div style={cssDivider} />}

		</Box>
	)
}

export default SectionItem

const sxContainer: SxProps = {
	height: 38, padding: "7px 0px 7px 10px",
	display: "flex", alignItems: "center",
	cursor: "pointer",

	fill: theme.palette.text.primary,
	borderRight: `0px solid ${theme.palette.secondary.main}`,
	transition: theme.transitions.create(['color', 'fill', 'border-right']),
}

const sxSelect: SxProps = {
	color: theme.palette.background.card,
	fill: theme.palette.background.card,
	borderRightColor: "#ffe491",
}

const sxDisabled: SxProps = {
	cursor: "default",
	opacity: .5,
}

const sxHighlight = (select: boolean): SxProps => ({
	borderRightWidth: "9px",
	color: select ? undefined : theme.palette.secondary.main
})

const sxIcon: SxProps = {
	width: 24,
	height: 24,
	mr: "5px",
}
const cssLabel = (compact: boolean): SxProps => ({
	flex: 1,
	fontSize: "12px",
	fontWeight: 500,
	opacity: compact ? 0 : 1,
	transition: theme.transitions.create(["opacity"]),
})

const sxBadge: SxProps = {
	'& .MuiBadge-badge': {
		top: "-2px",
		//right: "8px",
		left: "2px",
		boxShadow: "3px 3px 3px 0 rgb(0 0 0 / 30%)",
	},
}

const cssDivider: React.CSSProperties = {
	position: "absolute",
	bottom: 0, left: 10, right: 10,
	height: 1,
	boxShadow: '-2px 2px 0px 0 rgb(0 0 0 / 27%)',
}
